/* unplugin-vue-components disabled */import { render } from "./container_order_list.vue?vue&type=template&id=672078df&scoped=true"
import script from "./container_order_list.vue?vue&type=script&lang=js"
export * from "./container_order_list.vue?vue&type=script&lang=js"

import "./container_order_list.vue?vue&type=style&index=0&id=672078df&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672078df"]])

export default __exports__